import React, { useState, useRef, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Button, Image, Typography } from 'tfc-components';

import Container from '../Container';

import logo from 'assets/images/logo.png';
import useWindowDimensions from 'hooks/useWindowDemensions';
import mapModifiers from 'utils/functions';

export interface MenuProps {
  href: string;
  label: string;
}

interface HeaderProps {
  menu: MenuProps[];
  extendClasses?: string;
}

const Header: React.FC<HeaderProps> = ({ menu, extendClasses }) => {
  const { height } = useWindowDimensions();
  const [open, setOpen] = useState(false);
  const [fixed, setFixed] = useState(false);
  const sidebarRef = useRef<HTMLDivElement>(null);
  const navigation = useNavigate();

  const toggleSidebar = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpen((prev) => !prev);
  };

  const closeSidebar = () => {
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        open
        && sidebarRef.current
        && !sidebarRef.current.contains(event.target as Node)
      ) {
        closeSidebar();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setFixed(true);
      } else {
        setFixed(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header
      className={`${mapModifiers('o-header', fixed && 'fixed')}${extendClasses ? ` ${extendClasses}` : ''
        }`}
    >
      <Container fullWidth>
        <div className="o-header_wrapper">
          <div className="o-header_logo">
            <Image imgSrc={logo} alt="EVOL Field" ratio={186 / 41} />
          </div>
          <div
            className={mapModifiers('o-header_content', open && 'open')}
            style={{ '--var-height': `${height}px` } as React.CSSProperties}
          >
            <div className="o-header_menu">
              <div className="o-header_menu_list">
                {menu.map((item) => (
                  <NavLink
                    to={item.href}
                    className={({ isActive }) => mapModifiers('o-header_menu_item', isActive && 'active')}
                    onClick={closeSidebar}
                  >
                    {item.label}
                  </NavLink>
                ))}
              </div>
            </div>
            {/* <div className="o-header_language">
              <Icon iconName="world" size="20" />
              <Select
                className="o-header_language_select"
                name="language"
                defaultValue={
                  { label: 'Vie', value: 'vi' }
                }
                opts={[{
                  label: 'Vie',
                  value: 'vi'
                }, {
                  label: 'Eng',
                  value: 'en'
                }]}
                menuPlacement={width < 768 ? 'top' : 'bottom'}
                isSearchable={false}
              />
            </div> */}
          </div>
          <div className="o-header_actions">
            <Button onClick={() => navigation('/contact-us')} extendClasses="fButton fButton-sm">
              <Typography.Text extendClasses="f-14x20" fontweight="600">
                Book a Demo
              </Typography.Text>
            </Button>
            <button
              type="button"
              className={mapModifiers('o-header_hamburger', open && 'open')}
              onClick={toggleSidebar}
              aria-label="Toggle menu"
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>
      </Container>
    </header>
  );
};

export default Header;
